module.exports = __webpack_public_path__ + "img/layout2.9b802bc8.png";